import { render, staticRenderFns } from "./companyLists.vue?vue&type=template&id=1166e630&scoped=true&"
import script from "./companyLists.vue?vue&type=script&lang=js&"
export * from "./companyLists.vue?vue&type=script&lang=js&"
import style0 from "./companyLists.vue?vue&type=style&index=0&id=1166e630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166e630",
  null
  
)

export default component.exports